"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('local', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M9.85786438,32.7573593 C6.23857625,33.8431458 4,35.3431458 4,37 C4,40.3137085 12.954305,43 24,43 L24,43 C35.045695,43 44,40.3137085 44,37 C44,35.3431458 41.7614237,33.8431458 38.1421356,32.7573593",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M24,35 C32.6666667,29.3359832 37,23.2299226 37,16.6818182 C37,9.6778434 31.1797017,4 24,4 C16.8202983,4 11,9.6778434 11,16.6818182 C11,23.2299226 15.3333333,29.3359832 24,35 Z",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.outFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("circle", {
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.innerFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin,
    cx: "24",
    cy: "17",
    r: "5"
  }))));
});

exports.default = _default;